export const questions = [
    {
        id: "1",
        question: "Card title 1",
        answer: "Some quick example text to build on the card title and make up the bulk of the card's content.",
    },
    {
        id: "2",
        question: "Card title 2",
        answer: "Some quick example text to build on the card title and make up the bulk of the card's content.",
    },
    {
        id: "3",
        question: "Card title 3",
        answer: "Some quick example text to build on the card title and make up the bulk of the card's content.",
    },
    {
        id: "4",
        question: "Card title 4",
        answer: "Some quick example text to build on the card title and make up the bulk of the card's content.",
    },
    {
        id: "5",
        question: "Card title 5",
        answer: "Some quick example text to build on the card title and make up the bulk of the card's content.",
    },
];
